/*
 *
 * ChooseSuppliersModal
 *
 * @version 1.0.0
 * @author GitHub Copilot
 * @since 04-Sep-2025
 */
import React from 'react'
import MerchantGenericCard from '@nexidigital/merchantgenericcard'
import MerchantModal from '@nexidigital/merchantmodal'
import Toggle from 'Hoc/ToggleComponent'
import PropTypes from 'prop-types'
import DataRow from 'Components/DataRow'
import MerchantTableBadge from '@nexidigital/merchanttablebadge'
import formattedMessage from './languageModule'

const ChooseSuppliersModal = (props) => (
  <Toggle>
    <MerchantModal
      title={formattedMessage.modalTitle}
      withoutButton
      onClose={() => props.actions.doHidePopup()}
      topBarTitle=' '
    >
      <div className='pciModalContent'>
        <MerchantGenericCard>
          <div className='pciModalContentHeader'>
            <DataRow full label={formattedMessage.protectionLabel} content={formattedMessage.protectionValue} />
            <DataRow full label={formattedMessage.difficultyLabel} content={formattedMessage.difficultyValue} />
          </div>
        </MerchantGenericCard>
        <div className='pciModalContentValidity'>
          <p className='pciModalContentValidityText'>{formattedMessage.validForLabel}</p>
          <div className='pciModalContentValidityBadges'>
            <MerchantTableBadge symbol label={formattedMessage.ecommerceLabel} status='brand' />
            <MerchantTableBadge symbol label={formattedMessage.motoLabel} status='brand' />
            <MerchantTableBadge symbol label={formattedMessage.faceToFaceLabel} status='brand' />
          </div>
        </div>
        <MerchantGenericCard empty>
          <p>
            {formattedMessage.introText}
          </p>
          <div className='pciModalContentSection'>
            <h1 className='pciModalContentSectionTitle'>
              {formattedMessage.advise1Title}
            </h1>
            <p>
              {formattedMessage.advise1Text}
            </p>
            <h1 className='pciModalContentSectionTitle'>
              {formattedMessage.advise2Title}
            </h1>
            <p>
              {formattedMessage.advise2Text}
              <ul>
                <li>{formattedMessage.advise2Item1}</li>
                <li>{formattedMessage.advise2Item2}</li>
                <li>{formattedMessage.advise2Item3}</li>
              </ul>
            </p>
            <h1 className='pciModalContentSectionTitle'>
              {formattedMessage.advise3Title}
            </h1>
            <p>
              {formattedMessage.advise3Text}
            </p>
            <h1 className='pciModalContentSectionTitle'>
              {formattedMessage.advise4Title}
            </h1>
            <p>
              {formattedMessage.advise4Text}
            </p>
          </div>
        </MerchantGenericCard>
      </div>
    </MerchantModal>
  </Toggle>
)

ChooseSuppliersModal.propTypes = {
  actions: PropTypes.object
}

ChooseSuppliersModal.defaultProps = {
  action: {}
}

export default ChooseSuppliersModal
